import { loaderAction, setInvoiceSumFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { INVOICE_SUM_FORM_INITIAL } from "../initialStateConstant";
import { GetInvoicesThunk } from "./GetInvoicesThunk";

export const UpdateInvoiceSumThunk = (args) => async (dispatch, getState) => {
    const { user, invoices } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('invoice_id', args.invoice_id);
        formData.append('sum', args.sum);

        const response = await api({ data: formData, link: 'update_invoice_sum' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования суммы счёта
            dispatch(setInvoiceSumFormAction(INVOICE_SUM_FORM_INITIAL));

            // Обновляем список счетов
            dispatch(GetInvoicesThunk({ date: invoices.date }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};